import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--spacing-regular, 24px);
  padding: var(--spacing-regular, 24px);
  background-color: #ffffff;
`;

export const LogoWrapper = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-small, 16px);
`;

export const LogoImage = styled.img`
  max-height: 100%;
  max-width: 220px;
  object-fit: contain;
`;

export const Title = styled.h1`
  margin: 0;
  color: #000;
  font-family: Comfortaa !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.01em;
`;

export const SubTitle = styled.p`
  margin: 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  color: #525252;
  font-family: Comfortaa !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;
